import { render, staticRenderFns } from "./myPatient.vue?vue&type=template&id=2ce91965"
import script from "./myPatient.vue?vue&type=script&lang=js"
export * from "./myPatient.vue?vue&type=script&lang=js"
import style0 from "./myPatient.vue?vue&type=style&index=0&id=2ce91965&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports